import React from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Avatar } from '@mui/material';
import { green } from '@mui/material/colors';
import { Link } from "react-router-dom";
import MapIcon from '@mui/icons-material/Map';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';


const AtisLogo = (props) => {
  const theme = useTheme();
  const matchesLg = useMediaQuery(theme.breakpoints.up('lg'));
  let title = process.env.REACT_APP_TITLE;
  let sub = process.env.REACT_APP_SUB;
  const client = process.env.REACT_APP_CLIENT;

  var url = "/cdot_logo.png";
  var bgcolor = "#005899";
  if (matchesLg) {
    url = "/traffictracker.png";
  }

  if (matchesLg) {
    return (
      <Box
        sx={{
          flexGrow: 8,
          minHeight: 87,
          maxHeight: 87,
          height: 87,
          backgroundImage: 'url(' + url + ')',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left top',
        }}
        title={title}
      ></Box>
    )
  } else {
    return (
      <Box sx={{
        minHeight: 60,
        height: 72,
        pt: 1,
        backgroundColor: bgcolor,
        borderBottom: "#ffffff 3px dashed",
        pb: 2,
        ml: 1
      }} ><Typography variant="h6" sx={{ color: "#a4d5ee" }}>{title.toUpperCase()}</Typography>
        <Typography variant="body1" sx={{ color: "#fec240", textAlign: "left", ml: 1, fontWeight: "bold" }}>{sub}</Typography>
      </Box>
    )
  }
}

const MapHeaderDesktop = (props) => {
  const handleDrawerToggle = props.handleDrawerToggle;
  const loggedIn = props.loggedIn;
  const mobileOpen = props.mobileOpen;
  
  const logout = () => {
    const origin = window.location.origin;
    let subdir = process.env.REACT_APP_DIRECTORY;
    let redirect = origin + subdir  + "logout.jsp";
    window.location = redirect;
  }

  return (
    <>
      <Box>
        <IconButton
          color="inherit"
          aria-label="open or close sidebar"
          onClick={handleDrawerToggle}
          title="Open or Close Information"
        >
          <Avatar sx={!mobileOpen ? { bgcolor: "#a4d5ee" } : { bgcolor: green[500] }}>{
            mobileOpen ? <ArrowCircleRightIcon /> : <ArrowCircleLeftIcon />}</Avatar>
        </IconButton>
      </Box>

      <Box>
        <IconButton
          aria-label="login"
          title={loggedIn ? "Access User Settings" : "Login to Account"}
        >
          {loggedIn ?
            <Avatar sx={{ bgcolor: green[500] }}><Link to="/user"><AccountCircle /></Link></Avatar> : <Avatar sx={{ bgcolor: "#a4d5ee" }}><AccountCircle onClick={() => window.location.href = "/account"}></AccountCircle></Avatar>
          }
        </IconButton>
      </Box>

      {/* Logout button, only visible if loggedIn */}
      {loggedIn && (
        <Box>
          <IconButton
            aria-label="logout"
            title="Logout"
            onClick={() => logout()} 
          >
            <Avatar sx={{ bgcolor: "#a4d5ee" }}>
              <ExitToAppOutlinedIcon></ExitToAppOutlinedIcon> 
            </Avatar>
          </IconButton>
        </Box>
      )}
    </>
  )
}

const MapHeaderMobile = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleDrawerToggle = props.handleDrawerToggle;
  const loggedIn = props.loggedIn;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const logout = () => {
    const origin = window.location.origin;
    let subdir = process.env.REACT_APP_DIRECTORY;
    let redirect = origin + subdir  + "logout.jsp";
    window.location = redirect;
  }

  const handleAccountRedirect = () => {
    window.location.href = loggedIn ? "/user" : "/account";
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-haspopup="true"
        onClick={handleClick}
        sx={{ width: 50 }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
              bgcolor: 'background.paper'
            },
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleDrawerToggle}>
          <ListItemIcon>
            <ArrowCircleLeftIcon fontSize="small" />
          </ListItemIcon>
          Open Sidebar
        </MenuItem>
        <MenuItem onClick={handleAccountRedirect}>
          <ListItemIcon>
            <AccountCircle fontSize="small" sx={{ color: loggedIn ? green[500] : "inherit" }} />
          </ListItemIcon>
          {loggedIn ? "Access User Settings" : "Login to Account"}
        </MenuItem>
        
        {/* Logout button, only visible if loggedIn */}
        {loggedIn && (
          <MenuItem onClick={logout}> 
            <ListItemIcon>
              <ExitToAppOutlinedIcon fontSize="small" /> 
            </ListItemIcon>
            Logout
          </MenuItem>
        )}      
      </Menu>
    </>
  )
}

const MapHeader = (props) => {
  const theme = useTheme();
  const matchesLg = useMediaQuery(theme.breakpoints.up('lg'));

  if (matchesLg) {
    return <MapHeaderDesktop {...props} />
  } else {
    return <MapHeaderMobile {...props} />
  }

}

const UserHeader = (props) => {
  const setFooterSelection = props.setFooterSelection;
  const onButtonClick = (e) => {
    console.log("why is this firing all the time?")
    setFooterSelection(null)
  }
  return (
    <IconButton
      onClick={onButtonClick}
      aria-label="map">
      <Avatar sx={{ bgcolor: "#a4d5ee" }}><Link to="/"><MapIcon /></Link></Avatar>
    </IconButton>
  )
}


export default function Header(props) {

  const isUser = props.isUser;
  const theme = useTheme();
  const matchesLg = useMediaQuery(theme.breakpoints.up('lg'));
  //const orientation = useMediaQuery(theme.orientation('landscape'))
  var bgcolor = "#005899";

  const toolbar = (
    <>
      <Box sx={{ display: "flex", m: 0, p: 0, backgroundColor: bgcolor, minHeight: 87, height: 87, maxHeight: 87 }}>
        <AtisLogo {...props} />
        <Box sx={{
          flexGrow: 1,
          maxHeight: 87,
          display: "flex",
          justifyContent: "end",
          mt: 1,
          mr: 1
        }}>
          {!isUser &&
            <MapHeader {...props} />
          }
          {isUser &&
            <UserHeader {...props} />
          }
        </Box>
      </Box>
    </>
  )

  if (matchesLg) {
    return (
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1
        }}
      >
        {toolbar}
      </AppBar>
    )
  } else {
    return (
      <AppBar position="fixed">
        {toolbar}
      </AppBar>
    )
  }
}